import apiClient from '@u/apiClient'
import ElysGenerateKeyController from '@/wayfinder/actions/App/Http/Controllers/FuneralHomePartner/Elys/ElysGenerateKeyController'
import ElysCheckConnectionController from '@/wayfinder/actions/App/Http/Controllers/FuneralHomePartner/Elys/ElysCheckConnectionController'
import ElysSearchDeceasedsController from '@/wayfinder/actions/App/Http/Controllers/FuneralHomePartner/Elys/ElysSearchDeceasedsController'
import ElysGetMunicipalitiesController from '@/wayfinder/actions/App/Http/Controllers/FuneralHomePartner/Elys/ElysGetMunicipalitiesController'
import ElysEligibleCompaniesController from '@/wayfinder/actions/App/Http/Controllers/FuneralHomePartner/Elys/ElysEligibleCompaniesController'
import ElysGetDeceasedByIdController from '@/wayfinder/actions/App/Http/Controllers/FuneralHomePartner/Elys/ElysGetDeceasedByIdController'
import ElysDossierActionController from '@/wayfinder/actions/App/Http/Controllers/FuneralHomePartner/Elys/ElysDossierActionController'
import ElysGetTransportViewController from '@/wayfinder/actions/App/Http/Controllers/FuneralHomePartner/Elys/ElysGetTransportViewController'
import ElysGetDossiersController from '@/wayfinder/actions/App/Http/Controllers/FuneralHomePartner/Elys/ElysGetDossiersController'
import ElysPaiementController from '@/wayfinder/actions/App/Http/Controllers/FuneralHomePartner/Elys/ElysPaiementController'
import ElysActionController from '@/wayfinder/actions/App/Http/Controllers/FuneralHomePartner/Elys/ElysActionController'
import ElysGetDeceasedInformationSheetController from '@/wayfinder/actions/App/Http/Controllers/FuneralHomePartner/Elys/ElysGetDeceasedInformationSheetController'
import ElysSendDeceasedInformationSheetController from '@/wayfinder/actions/App/Http/Controllers/FuneralHomePartner/Elys/ElysSendDeceasedInformationSheetController'
import ElysGetDeceasedSocioEconomicInformationController from '@/wayfinder/actions/App/Http/Controllers/FuneralHomePartner/Elys/ElysGetDeceasedSocioEconomicInformationController'
import ElysGetCemeteriesController from '@/wayfinder/actions/App/Http/Controllers/FuneralHomePartner/Elys/ElysGetCemeteriesController'
import ElysGetCemeteryReservationController from '@/wayfinder/actions/App/Http/Controllers/FuneralHomePartner/Elys/ElysGetCemeteryReservationController'
import ElysSendCemeteryReservationController from '@/wayfinder/actions/App/Http/Controllers/FuneralHomePartner/Elys/ElysSendCemeteryReservationController'
import ElysSendDeceasedSocioEconomicInformationController from '@/wayfinder/actions/App/Http/Controllers/FuneralHomePartner/Elys/ElysSendDeceasedSocioEconomicInformationController'

export default {
  generateElysJWTKey({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(ElysGenerateKeyController.get({ company: payload.company_id }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  checkElysConnection({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          ElysCheckConnectionController.get({ company: payload.company_id })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  elysSearchDeceaseds({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          ElysSearchDeceasedsController.post({ company: payload.company_id }),
          payload.data
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  elysGetMunicipalities({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          ElysGetMunicipalitiesController.post({ company: payload.company_id }),
          payload.data
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  elysEligibleCompanies({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(ElysEligibleCompaniesController.get())
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  elysGetDeceasedById({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          ElysGetDeceasedByIdController.get({
            company: payload.company_id,
            dossier_id: payload.deceased_id
          }),
          payload.data
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  elysProcessAction({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          ElysDossierActionController.get({
            company: payload.company_id,
            dossier_id: payload.deceased_id,
            action: payload.action
          }),
          payload.data
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  elysGetDeceasedTransportViewById({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          ElysGetTransportViewController.get({
            company: payload.company_id,
            dossier_id: payload.deceased_id
          }),
          payload.data
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  elysGetDossiers({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(ElysGetDossiersController.get({ company: payload.company_id }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  proceedPaiment({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          ElysPaiementController.post({ company: payload.company_id }),
          payload.data
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  proceedAction({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          ElysActionController.post({ company: payload.company_id }),
          payload.data,
          payload.config
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  elysGetInformationSheet({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          ElysGetDeceasedInformationSheetController.get({
            company: payload.company_id,
            dossier_id: payload.deceased_id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  elysSendInformationSheet({ commit }, payload) {
    console.log(payload)
    let formData = new FormData()
    formData.append(
      'inlichtingenficheUitvaart',
      JSON.stringify(payload.data.form)
    )
    if (payload.data.file.VERZOEK_OPNAME_ALS_VADER_OF_MEEMOEDER) {
      formData.append(
        'VERZOEK_OPNAME_ALS_VADER_OF_MEEMOEDER',
        payload.data.file.VERZOEK_OPNAME_ALS_VADER_OF_MEEMOEDER,
        payload.data.file.VERZOEK_OPNAME_ALS_VADER_OF_MEEMOEDER.name
      )
    }
    if (
      payload.data.file
        .VERZOEK_NABESTAANDEN_PLAATSOVERLIJDEN_VERPLICHT_ALS_AS_PARTNER_VAN_TOEPASSING
    ) {
      formData.append(
        'VERZOEK_NABESTAANDEN_PLAATSOVERLIJDEN_VERPLICHT_ALS_AS_PARTNER_VAN_TOEPASSING',
        payload.data.file
          .VERZOEK_NABESTAANDEN_PLAATSOVERLIJDEN_VERPLICHT_ALS_AS_PARTNER_VAN_TOEPASSING,
        payload.data.file
          .VERZOEK_NABESTAANDEN_PLAATSOVERLIJDEN_VERPLICHT_ALS_AS_PARTNER_VAN_TOEPASSING
          .name
      )
    }
    if (payload.data.file.VERZOEK_NABESTAANDE) {
      formData.append(
        'VERZOEK_NABESTAANDE',
        payload.data.file.VERZOEK_NABESTAANDE,
        payload.data.file.VERZOEK_NABESTAANDE.name
      )
    }
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          ElysSendDeceasedInformationSheetController.post({
            company: payload.company_id,
            dossier_id: payload.deceased_id
          }),
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  elysGetSocioEconomicInformation({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          ElysGetDeceasedSocioEconomicInformationController.get({
            company: payload.company_id,
            dossier_id: payload.deceased_id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  elysSendSocioEconomicInformation({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          ElysSendDeceasedSocioEconomicInformationController.put({
            company: payload.company_id,
            dossier_id: payload.deceased_id
          }),
          payload.data
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  elysGetCemeteryReservation({ commit }, payload) {
    return apiClient
      .route(
        ElysGetCemeteryReservationController.get({
          company: payload.company_id,
          dossier_id: payload.deceased_id
        })
      )
      .then((response) => response.data)
  },
  elysSendCemeteryReservation({ commit }, payload) {
    return apiClient
      .route(
        ElysSendCemeteryReservationController.put({
          company: payload.company_id,
          dossier_id: payload.deceased_id
        }),
        payload.data
      )
      .then((response) => response.data)
  },
  elysGetCemeteries({ commit }, payload) {
    return apiClient
      .route(
        ElysGetCemeteriesController.get({
          company: payload.company_id,
          niscode: payload.niscode
        })
      )
      .then((response) => response.data)
  }
}
